/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ecommerce/028-favourite': {
    width: 512,
    height: 512,
    viewBox: '0 0 512.02 512.02',
    data: '<path pid="0" d="M245.059 263.159c5.886 6.061 15.629 6.07 21.523 0l72.806-74.98c25.594-26.209 25.582-68.827-.032-95.026-22.951-23.465-58.205-26.048-83.535-9.253-19.095-12.66-38.853-10.786-36.044-10.786-58.944 0-89.203 72.399-47.514 115.075zm-51.326-149.03c14.218-14.535 37.316-14.737 51.363-.373 5.875 6.007 15.559 6.02 21.447 0 14.044-14.359 37.143-14.166 51.362.371 13.555 13.865 15.354 37.41-.779 53.907-1.494 1.526 11.085-11.41-61.307 63.144-59.814-61.602-61.194-63.03-61.307-63.144-16.135-16.521-14.32-40.054-.779-53.905z"/><path pid="1" d="M440.413 0H71.606c-8.284 0-15 6.716-15 15v481.666c0 12.403 14.258 19.453 24.114 11.913l175.278-134.102L431.28 508.902c9.857 7.56 24.128.505 24.128-11.902l.004-482c.001-8.279-6.715-15-14.999-15zm-15.004 466.594L265.138 343.681a15 15 0 00-18.242-.011L86.606 466.304V30h338.807z"/>'
  }
})
